import { useState } from "react"
import axios from "axios"
import api from "../services/api"

// Extensão derivada do mime do arquivo. Enviamos `fileType` no POST /pedido-medico
// para o backend montar a KEY do S3 com a extensão correta (PDF ou imagem) — hoje a
// KEY ainda é fixa em .png no backend, ajuste pendente lá.
function getFileType(file) {
  if (file.type === "application/pdf") return "pdf"
  if (file.type === "image/png") return "png"
  if (file.type === "image/jpeg") return "jpg"
  if (file.type === "image/webp") return "webp"
  // fallback: extensão do nome
  const ext = file.name.split(".").pop()
  return ext ? ext.toLowerCase() : "png"
}

/**
 * Upload do encaminhamento médico em 2 etapas:
 *  1) pede a URL pré-assinada ao backend (POST /pedido-medico) mandando o CPF + fileType;
 *  2) faz PUT do binário direto no S3 (o arquivo nunca passa pelo Next/back).
 *
 * Retorna { url, loading, error, upload }. `url` é o link final do arquivo no S3,
 * pronto para entrar nas notas do agendamento.
 */
export default function useUploader() {
  const [url, setUrl] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function upload(file, clientCPF) {
    setLoading(true)
    setError(null)
    setUrl(null)

    try {
      const fileType = getFileType(file)
      const cpf = String(clientCPF || "").replace(/\D/g, "")

      // 1) URL pré-assinada (auth por cookie HttpOnly via api client, same-origin)
      const { data } = await api.post("/pedido-medico", { clientCPF: cpf, fileType })
      const { content: signedUrl, s3Key, protocol, host } = data

      // 2) PUT direto no S3 — sem credenciais, com o Content-Type do arquivo
      await axios.put(signedUrl, file, {
        headers: { "Content-Type": file.type }
      })

      const finalUrl = `${protocol}//${host}/${s3Key}`
      setUrl(finalUrl)
      setLoading(false)
      return finalUrl
    } catch (err) {
      setError("Não foi possível enviar o encaminhamento. Tente novamente.")
      setLoading(false)
      return null
    }
  }

  return { url, loading, error, upload }
}
